import { productCategories } from '../../../../constants/product-categories';
import { type ProductKeys } from '../../../../constants/products';

/**
 * Gets all nested products that should be excluded from individual display
 * since they'll be shown within their category sections.
 */
export const getNestedProducts: () => Set<ProductKeys> = (): Set<ProductKeys> => {
	const nestedProducts = new Set<ProductKeys>();
	Object.values(productCategories).forEach((categoryConfig) => {
		categoryConfig.products.forEach((productKey) => {
			// Skip the primary product of the category, only hide the nested ones
			if (productKey !== categoryConfig.productCategory) {
				nestedProducts.add(productKey);
			}
		});
	});
	return nestedProducts;
};
